import { Avatar, Divider, Grid, IconButton } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { authSelector } from "../../../features/auth/authSlice";
import { useKeycloak } from "../../../providers/KeycloakProvider";

import LoginIcon from "@mui/icons-material/Login";
import LogoutIcon from "@mui/icons-material/Logout";
import { Link } from "react-router-dom";
import styles from "../../../styles/header.module.css";
import { stringAvatar } from "../../utils/helperFunctions";

const Header = () => {
  const { user, isAuth } = useSelector(authSelector);
  const { keycloak } = useKeycloak();

  const handleLogout = () => {
    if (keycloak) {
      keycloak.logout();
    }
  };

  // Rôle : Affichage de l'état d'authentification
  // Avatar utilisateur : Affiche les initiales du nom
  // Bouton de déconnexion : Déconnecte de Keycloak et Redux
  // Gestion des états : Affiche login/logout selon l'état d'authentification

  const userInfo = user;
  const name =
    userInfo?.name ||
    `${userInfo?.firstname || ""} ${userInfo?.lastname || ""}`.trim() ||
    "User";

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
        className={styles.topBar}
        spacing={0.5}
        columns={12}
      >
        {/* <div className={styles.sloganUpp}><img src={sloganUpp} alt="sloganUpp" /></div> */}
        <div className={styles.sloganUpp}>
          Parce-qu'on on ne fait pas de la Formule 1<br />
          avec des karts
          <br />
          <span className={styles.sloganAuthUpp}>B.Louche</span>
        </div>
        {/* <div className={styles.sloganJN}><img src={slogan} alt="slogan" /></div> */}
        <div className={styles.sloganJN}>
          Automatique signifie automatique
          <br />
          <br />
          <span className={styles.sloganAuthJN}>J.Nicolas</span>
        </div>
        {/* <div className={styles.slogan}><img src={slogan} alt="slogan" /></div> */}
        <div className={styles.slogan}>
          La maintenance sans souffrance
          <br />
          <br />
          <span className={styles.sloganAuth}>A.Trebucq</span>
        </div>
        <Divider orientation="vertical" variant="middle" flexItem />
        <Grid item xs={2} display="flex" justifyContent="flex-end">
          {isAuth ? (
            <>
              {user?.hasItRole && (
                <Link to="profile" className={styles.link}>
                  <Avatar
                    {...stringAvatar(name, "black")}
                    className={styles.avatar}
                  />
                </Link>
              )}
              <IconButton className={styles.buttonIcon} onClick={handleLogout}>
                <LogoutIcon />
              </IconButton>
            </>
          ) : (
            <Link to="login" className={styles.link}>
              <IconButton className={styles.buttonIcon}>
                <LoginIcon />
              </IconButton>
            </Link>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default Header;
